





















import { Vue, Component } from 'vue-property-decorator'
import { getGapData } from '@/api/newPersion'
import InsideBarChart from '@/components/g2Charts/chartList/insideBarChart'
import { CommonMudule } from '@/store/modules/common'
import { GapRes, ChatdataItem } from '@/types/newPersion'
import { comdify2 } from '@/utils/validate'
import cardWraper from '@/common/cardMap/cardLayout/cardWraper.vue'
@Component({
  components: { InsideBarChart, cardWraper },
})
export default class extends Vue {
  labelPosition = 'age*value';
  adjust = [
    { type: 'dodge', dodgeBy: 'analyType', marginRatio: 0 },
    { type: 'stack' },
  ];

  discountAmount = 0;
  gapAmount = 0
  comdify2 = comdify2;
  chartOptions = {
    position: [],
    legendPosition: 'top',
    titleNextContent: '岁',
    stackContent: '',
    valueNextContent: '(元/年)',
  };

  chartData: ChatdataItem[] = [];
  created () {
    this.getData()
  }

  filterData (data: GapRes) {
    let count = 0
    const typeObj = {
      annuityAmount: '年金可提供金额',
      insuranceAmount: '社保养老金额',
      otherAmount: '其他收入可提供金额',
      rentAmount: '房租可提供金额',
    }
    const set = []
    const valueArr = Object.values(typeObj)
    const keysArr = Object.keys(typeObj)
    const { pensionDemands, pensionSupplies } = data
    if (
      pensionDemands &&
      pensionSupplies &&
      pensionDemands.length === pensionSupplies.length
    ) {
      while (count < data.pensionDemands.length) {
        for (let i = 0; i < 4; i++) {
          set.push({
            analyType: 't2',
            age: String(pensionSupplies[count].age),
            type: valueArr[i],
            value: pensionSupplies[count][keysArr[i]],
          })
        }
        set.push({
          analyType: 't1',
          age: String(pensionDemands[count].age),
          type: '养老需求',
          value: pensionDemands[count].demandAmount,
        })
        count++
      }
    }
    return set
  }

  private async getData () {
    const res = await getGapData({
      customerId: CommonMudule.customerId,
    })
    if (res.statusCode === 0 && res.data) {
      this.chartData = this.filterData(res.data)
      this.discountAmount = res.data.discountAmount
      this.gapAmount = res.data.gapAmount
    }
  }
}
